import React from "react";
import { Card } from "antd";
import PaymentsTable from "src/modules/sales/components/payments/PaymentTable";

const TransactionsTable: React.FC = () => (
  <Card title="Recent Payments" bordered={false}>
    {<PaymentsTable />}
  </Card>
);

export default TransactionsTable;
